import { __DEV__ } from "@/constants";
import { version } from "../../package.json";
import { datadogLogs } from "@datadog/browser-logs";
import { useUISlice } from "@/models/useUISlice";
import { useAuth } from "@/models/useAuth";
import { getMobileOperatingSystem, getLocale } from "@/models/utils";

if (typeof window !== "undefined" && !__DEV__) {
  try {
    const env = "prod";

    datadogLogs.init({
      clientToken: import.meta.env.VITE_PUBLIC_DATADOG_CLIENT_TOKEN,
      site: "datadoghq.com",
      forwardErrorsToLogs: true,
      service: "ezwording-web",
      env,
      version,
      sessionSampleRate: 100,
    });

    if (useAuth.isAuthenticated()) {
      const user = useAuth.currentAuthUser();
      datadogLogs.setUser({ id: user?.userId, email: user?.email });
    }
  } catch (error) {
    console.error("Error initializing Datadog", error);
  }
}

export type FunnelEvent =
  | "[0] - page visited"
  | "[1] - user authenticated"
  | "[2] - start voice typing"
  | "[3] - edit with AI"
  | "[4.1] - Copy"
  | "[4.2] - Downloaded As Docx"
  | "[5] - stripe checkout"
  | "[6] - stripe checkout success";

export const logFunnelEvent = (funnel: FunnelEvent) => {
  const user = useAuth.currentAuthUser();
  try {
    datadogLogs?.logger?.info(`[Funnel]${funnel}`, {
      funnelData: {
        platform: getMobileOperatingSystem(),
        isMobile: useUISlice?.getState()?.device?.isMobile,
        userId: user?.userId,
        email: user?.email,
        country: user?.country,
        ip: user?.ip,
        language: getLocale(),
        version,
      },
    });
  } catch (error) {}
};
